// Which page opens in the panel beside the chat, by URL. The URL is the only
// record of what is open, so a link, a refresh or the assistant's `navigate`
// tool all open the same thing (founder, 2026-09-27: "the chat also opens as
// individual cards only and differently on all the pages").
//
// Pages not listed keep their own full-width layout: Account, admin, the
// public pages and sign-in.
export const HOME_PATH = '/dashboard';
export const ABOUT_YOU_PATH = '/about-you';
// Its "What you want" section, by the heading's id (AboutYou.js ay-<section>).
// About you scrolls to a hash on load, so a "your preferences" link lands on
// them rather than on the top of a long page (2026-09-29).
export const ABOUT_YOU_WANTS = `${ABOUT_YOU_PATH}#ay-wants`;

// Names per the founder's decision (Jobs · Applications · Resume). Tracker
// and Interview coach get a tab only while one of them is open.
export const PANELS = [
  { path: '/for-you', label: 'Jobs', icon: 'work' },
  { path: '/job-agent', label: 'Applications', icon: 'send' },
  { path: '/design-studio', label: 'Resume', icon: 'description' },
  // Everything the product keeps about the person, in one list (founder,
  // 2026-09-28: named "About you"; beside the chat, which fills it in).
  { path: ABOUT_YOU_PATH, label: 'About you', icon: 'person' },
  { path: '/tracking', label: 'Tracker', icon: 'stacked_bar_chart', whileOpen: true },
  { path: '/interview-coach', label: 'Interview coach', icon: 'forum', whileOpen: true },
  // Every conversation, and a search across them (founder, 2026-09-28): a
  // page of its own, never a tab; the chat steps aside while it is open.
  { path: '/chats', label: 'Chats', icon: 'chat_bubble', page: true },
];

const under = (pathname, path) => pathname === path || pathname.startsWith(`${path}/`);

/** The panel a URL opens, or null (the home, or a page outside the shell). */
export const panelFor = (pathname = '') => PANELS.find(p => under(pathname, p.path)) || null;

/** Whether a URL lives in the shell at all: the home or one of the panels. */
export const isShellPath = (pathname = '') => under(pathname, HOME_PATH) || Boolean(panelFor(pathname));

/** The tabs across the panel's top for a URL. A page of its own is never one. */
export const tabsFor = (pathname = '') => PANELS.filter(p => !p.page && (!p.whileOpen || under(pathname, p.path)));

/**
 * The shell is for a signed-in person on anything wider than a phone. A phone
 * keeps today's screens until the phone sheet (plan phase 6); 768 is the
 * app's phone line, inclusive (App.js, NavigationPanel.js).
 */
export const PHONE_MAX = 768;
export const usesShell = ({ pathname, width, signedIn }) => Boolean(signedIn) && width > PHONE_MAX && isShellPath(pathname);
